import React, { useState } from "react";
import { toast } from "react-toastify";
import { copyToClipboard } from "../../../../utils/helpers";
import {
    buildProDemoScheduleLink,
    buildProDemoMediumLink,
} from "../../../../utils/bookingLinks";

export default function BookingLinkModal({ setOpenBookingLink, activeItem, medium_id }) {

    const [linkType, setLinkType] = useState("schedule"); // default selected option

    const eventName =
        (activeItem && activeItem.meta_data && activeItem.meta_data.title) ||
        (activeItem && activeItem.sessionName) ||
        "Pro Demo";

    const selectedLink =
        linkType === "schedule"
            ? buildProDemoScheduleLink(
                medium_id,
                activeItem !== undefined && activeItem !== null
                    ? activeItem.medium_availability_id
                    : ""
            )
            : buildProDemoMediumLink(medium_id);

    const handleChange = (e) => {
        setLinkType(e.target.value);
    };

    const closeHandler = () => {
        window.loadModal2("#BookingLinkModal", "hide");
        window.removeBackdrop();
        setTimeout(() => {
            setOpenBookingLink(false);
        }, 200);
    };

    const copyHandler = () => {
        copyToClipboard(selectedLink);
        toast.success("Copied", { position: "top-center" });
    };
    return (
        <div>
            <div
                id="BookingLinkModal"
                className="modal fade bd-example-modal-lg mt-5 preview-modal-availability overflow-scroll "
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myLargeModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog-preview">
                    <div className="modal-content">
                        <div className="modal-header position-relative">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Choose Link to Share
                            </h5>
                        </div>

                        <div className="meeting-preferences-box-row mb-2 mt-5 clear-both">
                            <h4 className="text-center">
                                Which Booking Link would you like to share?
                            </h4>
                        </div>
                        <div className="availability-window-table availability-window-table-1">
                            <table>
                                <tr>
                                    <td>
                                        <div class="form-group">
                                            <input
                                                type="radio"
                                                value="schedule"
                                                checked={linkType === "schedule"}
                                                onChange={handleChange}
                                                className="mr-2"
                                                name="booking-link-type"
                                                id="booking-link-schedule"
                                            />
                                            <label htmlFor="booking-link-schedule">
                                                {`Pro Demo: ${eventName} - whole Schedule`}
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div class="form-group">
                                            <input
                                                type="radio"
                                                value="medium"
                                                checked={linkType === "medium"}
                                                onChange={handleChange}
                                                className="mr-2"
                                                name="booking-link-type"
                                                id="booking-link-medium"
                                            />
                                            <label htmlFor="booking-link-medium">
                                                Pro Demo (All Schedules)
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className="form-group ml-4 mr-4">
                            <input
                                type="text"
                                className="form-control"
                                value={selectedLink}
                                readOnly
                            />
                        </div>
                        <div className="d-flex align-items-center justify-content-center mb-5">
                            <>
                                <button
                                    onClick={closeHandler}
                                    data-dismiss="modal"
                                    className="font-size-14 ml-3 mr-3 pointer learn-more-btn height-50"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={copyHandler}
                                    className="font-size-14 ml-3 mr-3 pointer learn-more-btn height-50"
                                >
                                    Copy Link
                                </button>
                            </>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
